module.exports = __webpack_public_path__ + "img/tramites-colores.86449af5.webp";